<template>
    <div class="player">
        <div class="meta p-1">
            <b-spinner small type="grow" variant="danger"></b-spinner>
            <span>{{ code }} <template v-if="isStaticVideo">({{ 'generated_warning' | lang }})</template></span>
        </div>
        <span class="volume text-white" @click="toggleMute" v-if="activeTimeout || isMuted">
            <fa-icon v-if="isMuted" icon="volume-off"></fa-icon>
            <fa-icon v-else icon="volume-up"></fa-icon>
        </span>
        <div v-if="isLoading" class="d-flex align-items-center justify-content-center loading">
            <b-spinner variant="light"></b-spinner>
        </div>
        <video autoplay playsinline ref="player"></video>
    </div>
</template>

<script>
import Hls from 'hls.js';
import { mapState, mapMutations } from 'vuex';
import moment from 'moment';

export default {
    props: ['url', 'code', 'estimatedDuration', 'isStaticVideo', 'drawStart'],

    data() {
        return {
            hls: undefined,
            isLoading: true,
            isMuted: false,

            activeTimeout: undefined,

            currentDrawStart: this.drawStart,
        };
    },

    computed: {
        ...mapState(['datetime']),

        actualElapsed() {
            return moment(this.datetime).diff(this.currentDrawStart, 'seconds');
        },
    },

    methods: {
        toggleMute() {
            const { player } = this.$refs;

            player.muted = !player.muted;
            this.isMuted = !this.isMuted;
        },

        setup() {
            const { player } = this.$refs;

            if (Hls.isSupported() && !this.isStaticVideo) {
                this.hls = new Hls();
                this.hls.loadSource(this.url);
                this.hls.attachMedia(player);

                this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
                    const promise = player.play();

                    if (promise) {
                        promise.catch(() => {
                            player.muted = true;
                            this.isMuted = true;
                            player.play();
                        });
                    }
                });
            } else {
                player.src = this.url;
                player.play();
            }

            const isAndroid = /(android)/i.test(navigator.userAgent);
            const isIOSLike = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);

            if (isAndroid || isIOSLike)
            {
                player.muted = true;
            }

            player.addEventListener('mousemove', () => {
                if (this.activeTimeout) {
                    clearTimeout(this.activeTimeout);
                }

                this.activeTimeout = setTimeout(() => this.activeTimeout = undefined, 2000);
            });

            let lastTime = 0;
            let stopTimeout;

            player.addEventListener('timeupdate', () => {
                if (this.actualElapsed > this.estimatedDuration * 2) {
                    this.$emit('finish');
                }

                if (player.currentTime == lastTime) {
                    stopTimeout = setTimeout(() => {
                        if (player.currentTime > this.estimatedDuration) {
                            this.$emit('finish');
                        } else {
                            this.isLoading = true;
                        }
                    }, 3000);
                } else {
                    clearTimeout(stopTimeout);
                    this.isLoading = false;
                }

                lastTime = player.currentTime;
            });
        },

        teardown() {
            if (this.hls) {
                this.hls.destroy();
            }
        },
    },

    watch: {
        url() {
            this.teardown();
            this.setup();
        },
    },

    mounted() {
        this.setup();
    },

    beforeDestroy() {
        this.teardown();
    },
}
</script>
